module.exports = __webpack_public_path__ + "img/je.8901e431.svg";